import { useSyncExternalStore } from 'react';

/**
 * Listen to all events that can change the `window.innerWidth` and `window.innerHeight`.
 *
 * @returns A function to unsubscribe the listener from all events.
 */
export function subscribeToWindowResize(listener) {
  window.addEventListener('resize', listener);
  window.addEventListener('orientationchange', listener);
  return () => {
    window.removeEventListener('resize', listener);
    window.removeEventListener('orientationchange', listener);
  };
}
export function useWindowViewWidth() {
  return useSyncExternalStore(subscribeToWindowResize, () => window.innerWidth);
}
export function useWindowViewHeight() {
  return useSyncExternalStore(subscribeToWindowResize, () => window.innerHeight);
}